import BabyStrollerIconPath from "@ingka/ssr-icon/paths/baby-stroller";

export default BabyStrollerIconPath;
